import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  groupLogo: null,
  groupLogoId: null,
  groupList: [],
  selectedGroup: null,
  loading: {
    pageLoading: false,
    buttonLoading: false,
    scrollLoading: false,
    profileImageLoading: false,
  },
  pageState: {
    total: 0,
    page: 0,
    pageSize: 10,
    totalPages: 0,
    searchedRecord: false,
    searchQuery: "",
  },
  coachesPageState: {
    total: 0,
    page: 0,
    pageSize: 10,
    totalPages: 0,
    searchedRecord: false,
    searchQuery: "",
  },
  athletesPageState: {
    total: 0,
    page: 0,
    pageSize: 10,
    totalPages: 0,
    searchedRecord: false,
    searchQuery: "",
  },
  teamAdminPageState: {
    total: 0,
    page: 0,
    pageSize: 10,
    totalPages: 0,
    searchedRecord: false,
    searchQuery: "",
  },
  groupPageState: {
    total: 0,
    page: 0,
    pageSize: 10,
    totalPages: 0,
    searchedRecord: false,
    searchQuery: "",
  },
  activeCoachesList: [],
  activeAthletesList: [],
  activeTeamAdminsList: [],
  selectedCoachesList: [],
  selectedAthletesList: [],
  selectedTeamAdminsList: [],
  groupList: [],
  selectedGroupList: [],
};

export const GroupReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_SELECTED_GROUP_DETAILS:
      return {
        ...state,
        selectedGroup: payload,
      };

    case ActionTypes.GROUP_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case ActionTypes.ACTIVATE_OR_DEACTIVATE_GROUP:
      return {
        ...state,
        selectedGroup: {
          ...state.selectedGroup,
          status: payload,
        },
      };

    case ActionTypes.GET_ACTIVE_COACHES_LIST:
      return {
        ...state,
        activeCoachesList:
          payload.page === 0
            ? payload.coachesList
            : [...state.activeCoachesList, ...payload.coachesList],
        coachesPageState: {
          ...state.coachesPageState,
          page: payload.page === 0 ? 1 : state.pageState.page + 1,
          total: payload.total,
          totalPages: payload.totalPages,
        },
      };

    case ActionTypes.GET_ACTIVE_ATHELETS_LIST:
      return {
        ...state,
        activeAthletesList:
          payload.page === 0
            ? payload.athletesList
            : [...state.activeAthletesList, ...payload.athletesList],
        pageState: {
          ...state.pageState,
          page: payload.page === 0 ? 1 : state.pageState.page + 1,
          total: payload.total,
          totalPages: payload.totalPages,
        },
      };

    case ActionTypes.GET_ACTIVE_TEAM_ADMINS_LIST:
      return {
        ...state,
        activeTeamAdminsList:
          payload.page === 0
            ? payload.teamAdminsList
            : [...state.activeTeamAdminsList, ...payload.teamAdminsList],
        teamAdminPageState: {
          ...state.teamAdminPageState,
          page: payload.page === 0 ? 1 : state.teamAdminPageState.page + 1,
          total: payload.total,
          totalPages: payload.totalPages,
        },
      };

    case ActionTypes.GET_ALL_GROUP_LIST:
      return {
        ...state,
        groupList:
          payload.page === 0
            ? payload.groupList
            : [...state.groupList, ...payload.groupList],
        groupPageState: {
          ...state.groupPageState,
          page: payload.page === 0 ? 1 : state.groupPageState.page + 1,
          total: payload.total,
          totalPages: payload.totalPages,
        },
      };

    case ActionTypes.SET_SELECTED_COACHES_LIST:
      return {
        ...state,
        selectedCoachesList: payload,
      };

    case ActionTypes.SET_SELECTED_ATHLETES_LIST:
      return {
        ...state,
        selectedAthletesList: payload,
      };

    case ActionTypes.SET_SELECTED_TEAM_ADMINS_LIST:
      return {
        ...state,
        selectedTeamAdminsList: payload,
      };

    case ActionTypes.SET_SELECTED_GROUPS_LIST:
      return {
        ...state,
        selectedGroupList: payload,
      };

    case ActionTypes.HANDLE_GROUP_LOGO_UPLOAD:
      return {
        ...state,
        groupLogo: payload.filePath,
        groupLogoId: payload.id,
      };

    case ActionTypes.SET_GROUP_SEARCH_QUERY:
      return {
        ...state,
        [payload.pageStateName]: {
          ...state[payload.pageStateName],
          searchQuery: payload.searchQuery,
        },
      };

    case ActionTypes.SET_GROUP_SEARCHED_RECORD:
      return {
        ...state,
        [payload.pageStateName]: {
          ...state[payload.pageStateName],
          searchedRecord: payload.status,
        },
      };

    case ActionTypes.RESET_GROUP_DATA:
      return initialState;

    default:
      return state;
  }
};
